import { CloseBoxIcon } from './CloseBoxIcon';

/**
 * author: Gabriel
 * id 0823D18B-529A-4B7E-8090-A913399A3D5E
 * name close-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-box.svg
 * tags
 * - Math 
 * - Form 
 */
export const ClearBoxIcon = CloseBoxIcon;
export default ClearBoxIcon